
import React from 'react';
import Layout from '@/components/Layout/Layout';

const SmsTermsPage = () => {
  return (
    <Layout>
      <div className="container mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold text-center mb-8">SMS Terms and Conditions</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="lead">
              Last updated: May 20, 2025
            </p>
            
            <p>
              These SMS Terms and Conditions ("SMS Terms") govern your opt-in to receive text messages from Carolina Trophy Roofs ("we," "our," or "us").
            </p>
            
            <h2 className="text-xl font-bold mt-8 mb-4">SMS Program Description</h2>
            <p>
              By opting in to receive SMS text messages from Carolina Trophy Roofs, you agree to receive text messages regarding:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Appointment reminders and scheduling</li>
              <li>Service updates and project status</li>
              <li>Promotional offers and discounts</li>
              <li>Follow-up satisfaction surveys</li>
              <li>Important notifications related to your roofing project</li>
            </ul>
            
            <h2 className="text-xl font-bold mt-8 mb-4">Frequency of Messages</h2>
            <p>
              The number of messages you receive will vary depending on your interactions with us and the services you've requested. Message and data rates may apply. You can expect to receive:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Appointment confirmation messages</li>
              <li>Reminder messages 24-48 hours before scheduled appointments</li>
              <li>Status updates during your roofing project (typically 1-3 messages per week while your project is active)</li>
              <li>Occasional promotional messages (not more than 4 per month)</li>
            </ul>
            
            <h2 className="text-xl font-bold mt-8 mb-4">How to Opt Out</h2>
            <p>
              You can stop receiving text messages at any time by replying "STOP" to any message we send you. After you send the message "STOP" to us, we will send you a reply message to confirm that you have been unsubscribed. After this, you will no longer receive SMS messages from us.
            </p>
            
            <p>
              If you want to join again, just sign up as you did the first time, and we will start sending SMS messages to you again.
            </p>
            
            <h2 className="text-xl font-bold mt-8 mb-4">Help or Support</h2>
            <p>
              If you need assistance with our SMS program, reply with the word "HELP" to any message we send you, or contact us at:
            </p>
            <p>
              Phone: (252) 302-2003<br />
              Email: Claims@CarolinaTrophyRoofs.com
            </p>
            
            <h2 className="text-xl font-bold mt-8 mb-4">Message and Data Rates</h2>
            <p>
              Message and data rates may apply for any messages sent to you from us and to us from you. If you have any questions about your text plan or data plan, it is best to contact your wireless provider.
            </p>
            
            <h2 className="text-xl font-bold mt-8 mb-4">Changes to SMS Terms</h2>
            <p>
              We may update these SMS Terms from time to time. We will notify you of any changes by posting the new SMS Terms on this page and, if the changes are significant, we will provide a more prominent notice.
            </p>
            
            <h2 className="text-xl font-bold mt-8 mb-4">Contact Us</h2>
            <p>
              If you have questions or comments about these SMS Terms, please contact us at:
            </p>
            <p>
              Carolina Trophy Roofs<br />
              104 S. Business Ct<br />
              Rocky Mount, NC 27804<br />
              Email: Claims@CarolinaTrophyRoofs.com<br />
              Phone: (252) 302-2003
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SmsTermsPage;
